// ─────────────────────────────────────────────────────────────────────────────
// Accumulator hash-chain (browser-safe; primitives injected via Hasher).
//
// ⚠️ OQ-10 PENDING FA SIGN-OFF.
//
// total_hashₙ = H( total_hashₙ₋₁ ‖ canonical(rowₙ) ),  total_hash₀ = H(GENESIS_SEED)
//
// Each total hash transitively commits to the entire ordered history row₁…rowₙ,
// so any edit / delete / reorder of a past row breaks the chain from that row on.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Fixed genesis label. Part of the chain contract — changing it invalidates every
 * existing chain, so it is code-pinned (the env override exists only for re-keying).
 */
export const GENESIS_SEED = 'MDU-INVOICING-LOG/OQ-10/v1';
const enc = new TextEncoder();
/** total_hash₀ = H(GENESIS_SEED). The first real row's `prevTotalHash`. */
export function computeGenesisTotalHash(hasher) {
    return hasher.sha256Hex(enc.encode(GENESIS_SEED));
}
/** row_hash = H(canonical(row)). */
export function computeRowHash(canonical, hasher) {
    return hasher.sha256Hex(canonical);
}
/**
 * total_hashₙ = H( utf8(prevTotalHashₙ₋₁) ‖ canonical(rowₙ) ).
 *
 * `prevTotalHash` is always exactly 64 hex chars, so prefixing it (delimiter-free)
 * is unambiguous: the boundary between the fixed-width hex prefix and the canonical
 * bytes can never shift.
 */
export function computeTotalHash(prevTotalHash, canonical, hasher) {
    const prevBytes = enc.encode(prevTotalHash);
    const combined = new Uint8Array(prevBytes.length + canonical.length);
    combined.set(prevBytes, 0);
    combined.set(canonical, prevBytes.length);
    return hasher.sha256Hex(combined);
}
//# sourceMappingURL=hash-chain.js.map